export default __webpack_public_path__ + "90c307561e6d855d0ef705939f32db5a.png";